import script from "./TeamSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamSection.vue?vue&type=script&setup=true&lang=ts"

import "./TeamSection.vue?vue&type=style&index=0&id=4dbdecf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dbdecf0"]])

export default __exports__